/**
 * connected-handlers-drawer.js
 */

import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { paths } from 'utils/routing';
import MenuDrawer from 'components/menu-drawer';
import BasicDrawerMenu from 'components/menu-drawer/menu/basic-drawer-menu';
import { connectionsPath } from './connected-handlers';
import ConnectedHandlersView from './connected-handlers-view'
import { ReactComponent as GroupsImage } from 'assets/images/groups.svg';


const ConnectedHandlersMenu = (props) => {
  return (
    <BasicDrawerMenu 
      baseUrl={`${paths.groups.base}/${connectionsPath}`}
      items={[{
        key: 'connected-handlers-menu',
        iconName: 'group-handlers',
        label: 'Connected Handlers',
        path: '',
        backgroundImage: <GroupsImage />
      }]}
    />
  );
}


export default function ConnectedHandlersDrawer(props) {
  const history = useHistory();
  const basePath = useRouteMatch();
  const drawerPath = `/${connectionsPath}`;


  const onCloseDrawer = () => {
    if (props.onClose) {
      props.onClose();
    }
    history.push(basePath.url);
  } 


  return (
    <MenuDrawer
      {...props}
      title='CONNECTED HANDLERS'
      className='connected-handlers-drawer'
      basePath={basePath.url}
      drawerPath={drawerPath}
      onClose={onCloseDrawer}
      menuRoutes={[{
        component: ConnectedHandlersMenu,
        path: [basePath.url + paths.groups.connections.path]
      }]}
      desktopRoutes={[{
        component: ConnectedHandlersView,
        path: [basePath.url + paths.groups.connections.path]
      }]}
      mobileRoutes={[{
        component: ConnectedHandlersView,
        path: [basePath.url + paths.groups.connections.path]
      }]}
    />
  )
}